export const WATCHLIST_LIST_ATTEMPT = "WATCHLIST_LIST_ATTEMPT";
export const WATCHLIST_LIST_SUCCESS = "WATCHLIST_LIST_SUCCESS";
export const WATCHLIST_LIST_FAILED = "WATCHLIST_LIST_FAILED";
//////////////////
export const WATCHLIST_NEW_SUCCESS = "WATCHLIST_NEW_SUCCESS";
export const WATCHLIST_NEW_FAILED = "WATCHLIST_NEW_FAILED";
///////////////////
export const WATCHLIST_REMOVE_SUCCESS = "WATCHLIST_REMOVE_SUCCESS";
export const WATCHLIST_REMOVE_FAILED = "WATCHLIST_REMOVE_FAILED";

export const WATCHLIST_SET_ITEM = "WATCHLIST_SET_ITEM";
export const WATCHLIST_REORDER_SUCCESS = "WATCHLIST_REORDER_SUCCESS";



